import { FleetTime } from '@src/main/modules/ibdp/domain/fleet-time.interface';
import { IbdpRepository } from '@src/main/modules/ibdp/domain/ibdp.repository';

export const findFleets = async (
  repository: IbdpRepository,
  fleet: string,
  subFleet: string,
): Promise<FleetTime[]> => await repository.findFleets(fleet, subFleet);
